// extracted by mini-css-extract-plugin
export default {"wrap":"JE69MPBi","title":"bfNPfhi2"};